// extracted by mini-css-extract-plugin
module.exports = {"mobileMessagesHolder":"MobileMessages_mobileMessagesHolder__2eb1q","mobileMessagesHolderNoMessages":"MobileMessages_mobileMessagesHolderNoMessages__3BNRx"};